import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { User } from '../types';

interface AuthState {
  apiKey: string | null;
  user: User | null;
  isAuthenticated: boolean;
  isAdmin: boolean;
  
  // Actions
  setAuth: (apiKey: string, user: User) => void;
  logout: () => void;
  updateUser: (user: Partial<User>) => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      apiKey: null,
      user: null,
      isAuthenticated: false,
      isAdmin: false,
      
      setAuth: (apiKey: string, user: User) => {
        set({
          apiKey,
          user,
          isAuthenticated: true,
          isAdmin: user.role === 'admin',
        });
      },
      
      logout: () => {
        set({
          apiKey: null,
          user: null,
          isAuthenticated: false,
          isAdmin: false,
        });
      },
      
      updateUser: (updates: Partial<User>) => {
        const currentUser = useAuthStore.getState().user;
        if (currentUser) {
          set({
            user: { ...currentUser, ...updates },
          });
        }
      },
    }),
    {
      name: 'myaigc-auth',
    }
  )
);
